import React, { Component } from 'react';
import { connect } from 'react-redux';
import { HOME_RESIZE_LIMITS, HOME_TOPIC_ID, MAIN_SECTIONS, PATH } from '../../../constants';
import './Home.css';
import { saveLastLocation } from '../../../redux/actions';
import HomeLine from './HomeLine/HomeLine';
import HomeLineProgram from './HomeLineProgram/HomeLineProgram';
import HomeFoot from './HomeFoot/HomeFoot';

class Home extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.saveLastLocation(this.props.match.url);
  }

  render() {
    const { menuVisible, menuOverlay } = this.props;

    // calc grid
    let grid = 1;
    for (let i = 0; i < HOME_RESIZE_LIMITS.GRID.length; i += 1) {
      // calc width
      let checkWidth = this.props.width;
      if (menuVisible && !menuOverlay) {
        checkWidth -= HOME_RESIZE_LIMITS.MENU;
      }

      // check
      if (checkWidth > HOME_RESIZE_LIMITS.GRID[i][0]) {
        grid = HOME_RESIZE_LIMITS.GRID[i][1];
        break;
      }
    }

    // set lines
    const sectionLines = MAIN_SECTIONS.map((section, index) => (
      <HomeLine key={section.range} grid={grid} lineId={index} />
    ));

    return (
      <div id="wrap-home">
        <img
          id="logo-prix"
          src={`${PATH.IMG}homepage/logo-prix.png`}
          alt=""
        />
        <div className="head-wrap">
          <img
            id="header-cover"
            src={`${PATH.IMG}homepage/header.png`}
            alt="Úvod"
          />
        </div>
        <div>
          <HomeLine grid={grid} lineId={HOME_TOPIC_ID} />
          {sectionLines}
          <HomeLineProgram />
        </div>
        <HomeFoot />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  width: state.resize.width,
  menuVisible: state.resize.menuVisible,
  menuOverlay: state.resize.menuOverlay,
});

const mapDispatchToProps = dispatch => ({
  saveLastLocation: lastLocation => dispatch(saveLastLocation(lastLocation)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Home);



// WEBPACK FOOTER //
// ./src/components/App/Home/Home.js